export const alfredUrl = process.env.REACT_APP_ALFRED_URL || 'https://login.beta.theemployeeapp.com'
export const defaultDomain = process.env.REACT_APP_DEFAULT_DOMAIN || 'theemployeeapp.com'
export const subDomain = process.env.SUBDOMAIN || 'rtregcode.beta'
